var _g, _g2, _g3, _path, _g4, _path2, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgEmbraceMastery = function SvgEmbraceMastery(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 501 408"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#embrace_mastery_svg__a)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 400.841,
    height: 145.913,
    x: 88.29,
    y: 170.839,
    fill: "#fff",
    stroke: "#EDEDED",
    strokeWidth: 1.677,
    rx: 12.579
  }), /*#__PURE__*/React.createElement("rect", {
    width: 362.266,
    height: 16.772,
    x: 107.577,
    y: 190.126,
    fill: "#EDEDED",
    rx: 8.386
  }), /*#__PURE__*/React.createElement("rect", {
    width: 140.881,
    height: 16.772,
    x: 107.577,
    y: 220.314,
    fill: "#EDEDED",
    rx: 8.386
  }), /*#__PURE__*/React.createElement("rect", {
    width: 218.031,
    height: 16.772,
    x: 107.577,
    y: 280.693,
    fill: "#EDEDED",
    rx: 8.386
  }), /*#__PURE__*/React.createElement("rect", {
    width: 130.818,
    height: 16.772,
    x: 339.025,
    y: 280.693,
    fill: "#EDEDED",
    rx: 8.386
  }), /*#__PURE__*/React.createElement("rect", {
    width: 179.456,
    height: 16.772,
    x: 107.577,
    y: 250.503,
    fill: "#EDEDED",
    rx: 8.386
  }), /*#__PURE__*/React.createElement("rect", {
    width: 40.252,
    height: 16.772,
    x: 300.45,
    y: 250.503,
    fill: "#EDEDED",
    rx: 8.386
  }), /*#__PURE__*/React.createElement("rect", {
    width: 115.724,
    height: 16.772,
    x: 354.119,
    y: 250.503,
    fill: "#EDEDED",
    rx: 8.386
  }), /*#__PURE__*/React.createElement("rect", {
    width: 207.968,
    height: 16.772,
    x: 261.876,
    y: 220.314,
    fill: "#EDEDED",
    rx: 8.386
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#embrace_mastery_svg__b)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 400.841,
    height: 145.913,
    x: 11.29,
    y: 59.839,
    fill: "#fff",
    stroke: "#51C394",
    strokeWidth: 1.677,
    rx: 12.579
  }), /*#__PURE__*/React.createElement("rect", {
    width: 362.266,
    height: 16.772,
    x: 30.577,
    y: 79.126,
    fill: "#E2FFEA",
    rx: 8.386
  }), /*#__PURE__*/React.createElement("rect", {
    width: 140.881,
    height: 16.772,
    x: 30.577,
    y: 109.314,
    fill: "#E2FFEA",
    rx: 8.386
  }), /*#__PURE__*/React.createElement("rect", {
    width: 218.031,
    height: 16.772,
    x: 30.577,
    y: 169.693,
    fill: "#E2FFEA",
    rx: 8.386
  }), /*#__PURE__*/React.createElement("rect", {
    width: 130.818,
    height: 16.772,
    x: 262.025,
    y: 169.693,
    fill: "#E2FFEA",
    rx: 8.386
  }), /*#__PURE__*/React.createElement("rect", {
    width: 179.456,
    height: 16.772,
    x: 30.577,
    y: 139.503,
    fill: "#E2FFEA",
    rx: 8.386
  }), /*#__PURE__*/React.createElement("rect", {
    width: 40.252,
    height: 16.772,
    x: 223.45,
    y: 139.503,
    fill: "#E2FFEA",
    rx: 8.386
  }), /*#__PURE__*/React.createElement("rect", {
    width: 115.724,
    height: 16.772,
    x: 277.119,
    y: 139.503,
    fill: "#E2FFEA",
    rx: 8.386
  }), /*#__PURE__*/React.createElement("rect", {
    width: 207.968,
    height: 16.772,
    x: 184.876,
    y: 109.314,
    fill: "#E2FFEA",
    rx: 8.386
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#embrace_mastery_svg__c)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 59.518,
    height: 59.518,
    fill: "#3B7CC9",
    rx: 16,
    transform: "matrix(-1 0 0 1 451.97 36)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M416.603 51.952a1.722 1.722 0 0 0-3.081 0l-5.146 10.293-.042.083-1.701 3.402a1.723 1.723 0 0 0 3.081 1.54l1.246-2.492h8.205l1.222 2.444a1.7 1.7 0 0 0 .465.604 1.7 1.7 0 0 0 1.126.396h1.571a12.1 12.1 0 0 0 2.664 7.346c-1.215.678-2.679 1.136-4.397 1.27a1.723 1.723 0 0 0 .27 3.435c2.69-.212 4.948-1.046 6.754-2.278 1.807 1.232 4.065 2.066 6.755 2.278a1.721 1.721 0 1 0 .269-3.434c-1.717-.135-3.182-.593-4.396-1.271a12.1 12.1 0 0 0 2.664-7.346h1.597a1.722 1.722 0 0 0 0-3.444h-5.167v-1.722a1.722 1.722 0 1 0-3.444 0v1.722h-4.102zm14.085 16.27h-3.696a8.6 8.6 0 0 0 1.848 5.115 8.6 8.6 0 0 0 1.848-5.115m-13.245-6.888-2.38-4.76-2.381 4.76zm-2.381 6.888c.951 0 1.722.771 1.722 1.723v1.722h1.723a1.722 1.722 0 0 1 0 3.444h-3.445a1.72 1.72 0 0 1-1.722-1.722v-3.444c0-.952.771-1.723 1.722-1.723m12.056-10.333a1.722 1.722 0 1 0 3.444 0v-3.444c0-.952-.771-1.723-1.722-1.723h-3.444a1.722 1.722 0 1 0 0 3.445h1.722z",
    clipRule: "evenodd"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#embrace_mastery_svg__d)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 59.518,
    height: 59.518,
    fill: "#FFB800",
    rx: 16,
    transform: "matrix(-1 0 0 1 170.97 288)"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.375,
    d: "m147.333 317.288-5.384-4.038a1.585 1.585 0 0 0-1.9 0l-5.383 4.038m9.5 3.958-3.167-2.375-3.166 2.375"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 2.375,
    d: "M126.75 315.493c0-5.063 0-7.595.599-8.447.596-.85 2.976-1.665 7.737-3.295l.908-.31c2.481-.85 3.72-1.274 5.006-1.274 1.284 0 2.525.424 5.007 1.274l.907.31c4.761 1.63 7.141 2.445 7.738 3.295.598.852.598 3.386.598 8.447v2.493c0 3.966-1.325 7.025-3.167 9.362m-25.027-6.181c1.357 6.805 6.939 10.312 10.617 11.917 1.142.499 1.714.749 3.327.749 1.615 0 2.185-.25 3.327-.749a24 24 0 0 0 3.006-1.574"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "embrace_mastery_svg__a",
    width: 422.876,
    height: 167.947,
    x: 77.273,
    y: 164.821,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.089
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_578_13246"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_578_13246",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "embrace_mastery_svg__b",
    width: 422.876,
    height: 167.947,
    x: 0.273,
    y: 53.911,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5.089
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.089
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_578_13246"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_578_13246",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "embrace_mastery_svg__c",
    width: 152.103,
    height: 152.102,
    x: 348.804,
    y: 0.289,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2.645,
    dy: 10.581
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 23.146
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_578_13246"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_578_13246",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "embrace_mastery_svg__d",
    width: 152.103,
    height: 152.102,
    x: 67.804,
    y: 252.289,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2.645,
    dy: 10.581
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 23.146
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_578_13246"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_578_13246",
    result: "shape"
  })))));
};
export default SvgEmbraceMastery;